import React, { useEffect } from "react";

import ApplicationLayout from "components/ApplicationLayout";
import Navbar from "components/Navbar";
import PageContent from "components/PageContent";
import SharedFooter from "components/SharedFooter";
import Button from "components/Button";
import SendDownloadLink from "components/SendDownloadLink";

import TeamsRedirectLogoHeader from "assets/teams/teams-redirect-logo-header.svg";

import { Page } from "types/page";

import styles from "./redirect.module.css";

const Redirect: Page = () => {
  useEffect(() => {
    const { matches: isMobile } = window.matchMedia("(min-width: 600px)");

    if (!isMobile) return;

    const raycastFlavor = window.localStorage.getItem("raycastBuildTarget") || "raycast";
    window.location.href = `${raycastFlavor}://organization/create`;
  }, []);

  return (
    <div className={styles.container}>
      <TeamsRedirectLogoHeader />
      <div className={styles.desktop}>
        <div>
          <h1>You are being redirected to the app</h1>
          <p>Haven&rsquo;t got Raycast installed?</p>
        </div>

        <div>
          <Button
            renderAs="a"
            onClick={(event) => {
              event.preventDefault();
              window.location.href = "https://api.raycast.app/v2/download";
            }}
            className={styles.downloadButton}
            href="#download"
          >
            Download Raycast for Mac
          </Button>
        </div>
      </div>
      <div className={styles.mobile}>
        <div>
          <h1>Get a Download Link</h1>
          <p>
            Raycast isn&rsquo;t available on mobile. Send yourself a download link, and install the app on your Mac.
          </p>
        </div>

        <div>
          <SendDownloadLink />
        </div>
      </div>
    </div>
  );
};

Redirect.getLayout = (page) => {
  return (
    <ApplicationLayout>
      <div className={styles.bgGlow}></div>
      <Navbar />
      <PageContent>{page}</PageContent>
      <SharedFooter />
    </ApplicationLayout>
  );
};

export default Redirect;
